import AxiosAPI from '../../../utils/AxiosAPI';

export const handleLoadInvoiceListData = (params) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/`, {
                q: params.q || '',
                status: params.status || '',
                orderby: params['order-by'] || '',
                sort: params.sort || '',
                page: params.page || 1,
                cpp: 12
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });

export const handleLoadInvoiceInfo = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/${id}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });

// payment receive
export const handlePaymentReceive = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/${id}/receive-payment/`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// subscription create
export const handleCreateSubscription = (invoiceId, itemId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/${invoiceId}/create-subscription/${itemId}`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// update information
export const ApiUpdateInvoiceInfo = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/${id}/update-info/`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// update note
export const ApiUpdateInvoiceNote = (id, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/${id}/update-note/`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Cancel pending invoice
export const ApiPendingInvoiceCancel = (invoiceId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/${invoiceId}/cancel/`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Update VAT type and percent for a single invoice line item
export const ApiUpdateItemVat = (invoiceId, itemId, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/${invoiceId}/service-items/${itemId}/update-vat`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch(reject);
    });

export default null;
